import * as React from 'react';
import { StyleDataService, SurveyVersionDataService } from '../../services';
import { Style, SurveyVersion } from '../../models';
import { NavLink } from 'react-router-dom';
import { DataGrid } from '../../components';
import { BaseRouteProps } from '../../interfaces';
import { UserStore } from '../../stores';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';

interface StyleListState {
    entities: Array<Style>;
    surveyIsPublished: boolean;
}

interface StyleListingProps extends BaseRouteProps<{ id: number }> {
    UserStore?: UserStore;
}

@inject('UserStore') @observer
export class StyleListing extends React.Component<StyleListingProps, StyleListState> {
    private styleDataService = new StyleDataService(this.props.notificationService);
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);

    @computed get isSuperAdmin() {
        return this.props.UserStore!.userRoleIn(['superAdmin']);
    }

    constructor(props: StyleListingProps) {
        super(props);

        this.state = {
            entities: new Array<Style>(),
            surveyIsPublished: true
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.get(this.props.match.params.id).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyIsPublished: surveyVersion.published !== null ? true : false
            });

            this.styleDataService.getAllBySurveyVersion(surveyVersion).then((resp: Style[]) => {
                this.setState({
                    entities: resp
                });
            });
        });
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name + ` (${entity.core})`,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <NavLink className="btn btn-default btn-block" to={`/style/${value}`}>View</NavLink>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-xs-7">
                                <div className="title">
                                    <NavLink to={'/surveyversion/' + this.props.match.params.id}>
                                        <span className="glyphicon glyphicon-triangle-left" />
                                    </NavLink>
                                    &nbsp;
                                    Styles on Survey
                                </div>
                            </div>
                            {(this.isSuperAdmin && !this.state.surveyIsPublished) &&
                                <div className="col-xs-5 text-right">
                                    <NavLink className="btn btn-primary" to={'/surveyversion/' + this.props.match.params.id + '/styles/create'}>
                                        <span className="glyphicon glyphicon-plus" /> Create
                                    </NavLink>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <DataGrid entities={listData} columns={columnDefs} />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/style/StyleListing.tsx